/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";


/**
 * Tables store
 */
window.$(".saveTablesCombination").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveTablesCombination').attr('disabled', 'disabled');
    window.axios({
            method: "post",
            url: window.$(".tablesCombinationForm").attr('action'),
            data: window.$(".tablesCombinationForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);

        })
        .catch(function(error) {
            window.$('.saveTablesCombination').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Tables update
 */
window.$(".updateTableCombination").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateTableCombination').attr('disabled', 'disabled');
    window.axios({
            method: "PUT",
            url: window.$(".tableCombinationUpdateForm").attr('action'),
            data: window.$(".tableCombinationUpdateForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function(error) {
            window.$('.updateTableCombination').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Tables table listing
 */

var table = window.$('.TablesCombinationTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".TablesCombinationTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'id', name: 'id', "visible": false },
        { data: 'name', name: 'name' },
        { data: 'area', name: 'area' },
        { data: 'area_status', name: 'area_status' },
        { data: 'tables_name', name: 'tables_name' },
        { data: 'min_occupancy', name: 'min_occupancy' },
        { data: 'max_occupancy', name: 'max_occupancy' },
        { data: 'priority', name: 'priority' },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ],
    columnDefs: [{
        targets: [4, 5, 6],
        
    }]
});

/**
 * Tables Delete
 */
window.$(document).on('click', '.tablesCombination .deleteTables', function(e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function(result) {
        // If confirmation true, do action for delete
        var myTable = $(".TablesCombinationTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".TablesCombinationTable").attr('link')
        });
        e.preventDefault();
        window.axios({
                method: "DELETE",
                url: currentObj.attr('link')
            })
            .then(function(response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function(error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function(err) {
        console.log(err);
        return false;
    });

});

// Populate combination tables dropdown for selected area
window.$(document).on('change', '.tablesCombination #area', function(e) {
    // get selected area id
    var area_id = $(this).val();
    var tables_id = window.$(this).data('tables_id');

    window.axios({
            method: "post",
            url: window.$(this).data('url'),
            data: {
                'area_id': area_id,
                'tables_id': tables_id,
                'status_include':'inactive'
            }
        })
        .then(function(response) {
            window.$('#tablesCombinationSelectInput').html(response.data);
            window.$('.tablesCombination .multi-selection').select2({
                placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER
            });
        })

});

window.$(document).ready(function() {
    // Setup - add a text input to each footer cell
    var excluded_columns = [7, 8];
    searchByTableColumns(table, '#tablesCombination', excluded_columns);
});